import React, {useEffect, useMemo, useState} from "react";
import {Divider, FlexboxGrid, Progress, Tooltip, Whisper} from "rsuite";
import BasicStatBox from "./BasicStatBox";
import {useSelector} from "react-redux";
import {getUserDashboard} from "../../service/userService";
import {Check, Close} from "@rsuite/icons";

const style = {
    paddingTop: '50px',
};

const flexItemStyle = {
    margin: '10px',
}

const BasicUserDashboard = () => {
    const [percentComplete, setPercentComplete] = useState(0);
    const [userData, setUserData] = useState({});
    const [completionItems, setCompletionItems] = useState({});
    const userInfo = useSelector((state) => state.user.userInfo );

    useEffect(() => {
        getUserDashboard(userInfo?.id).then((userDashboardData) => {
            setUserData(userDashboardData);
            // simple for now - 2 parts, skills and experience for 100% complete
            // some people might not have degrees or certs
            let complete = 0;
            let completedItems = {};
            if (userDashboardData.skillCount > 0) {
                complete += 50;
                completedItems.skills = 1;
            }
            if (userDashboardData.yearsOfExperience !== '0 years, 0 months') {
                complete += 50;
                completedItems.exp = 1;
            }
            setPercentComplete(complete);
            setCompletionItems(completedItems);
        });
    }, [userInfo]);

    return useMemo(() => {
        return (
            <>
                <FlexboxGrid justify="center" style={style}>
                    <Whisper speaker={
                        <Tooltip style={{display: 'grid', gridTemplateRows: '1fr 1fr 1fr'}}>
                            <p>Your Resume Completion</p>
                            <div>{completionItems.skills ? <Check /> : <Close />} Skills</div>
                            <div>{completionItems.exp ? <Check /> : <Close />} Experience</div>
                        </Tooltip>}>
                        <FlexboxGrid.Item colspan={4} style={flexItemStyle}>
                            <Progress.Circle
                                percent={percentComplete}
                                strokeColor={"#3CB7EA"}
                            />
                        </FlexboxGrid.Item>
                    </Whisper>
                    <FlexboxGrid.Item colspan={4} style={flexItemStyle}><BasicStatBox header="Last Updated" content={userData.lastUpdated}/></FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={4} style={flexItemStyle}><BasicStatBox header="Years of Experience" content={userData.yearsOfExperience}/></FlexboxGrid.Item>
                </FlexboxGrid>
                <Divider>Summaries</Divider>
                <FlexboxGrid justify="center">
                    <FlexboxGrid.Item colspan={4} style={flexItemStyle}><BasicStatBox header="Skill Count" content={userData.skillCount}/></FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={4} style={flexItemStyle}><BasicStatBox header="Degree Count" content={userData.degreeCount}/></FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={4} style={flexItemStyle}><BasicStatBox header="Certification Count" content={userData.certCount}/></FlexboxGrid.Item>
                </FlexboxGrid>
            </>
        );
    }, [completionItems, percentComplete, userData]);
}

export default BasicUserDashboard;